import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const DottedSpinner = () => (
  <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
    <span style={{
      display: "inline-block",
      width: 18,
      height: 18,
      borderRadius: "50%",
      border: "2.5px dotted rgba(255,255,255,0.9)",
      animation: "dotted-spin 0.8s linear infinite",
    }} />
  </span>
);

const SaveButton = ({
  formik = null,
  buttonText = null,
  submitFunction = null,
  style = null,
  className = "btn btn-primary btn-rounded",
  isSaving = false,
}) => {
  const { t } = useTranslation();

  buttonText = buttonText ? buttonText : t("Backend.Buttons.Save");

  return (
    <>
      <Button
        className={className}
        onClick={(e) => {
          submitFunction && submitFunction(e);
          formik && formik.handleSubmit(e);
          e.preventDefault();
        }}
        style={{ minWidth: 80, ...(style || {}) }}
      >
        {isSaving ? <DottedSpinner /> : buttonText}
      </Button>
    </>
  );
};

export default SaveButton;
